jQuery(document).ready(function($) {

    $('.brand-carousel').owlCarousel({
      loop:true,
      margin:50,
      autoplay:true,
      nav: false,
      dots: false,
      autoplayTimeout:5000,
      autoplaySpeed: 9000,
      responsive:{
        0:{
          items:2
        },
        600:{
          items:3
        },
        1000:{
          items:6
        }
      }
    });



   $('.customers-testimonials').owlCarousel({
	 loop: true,
     center: true,
	 autoplay: false,
     autoplayHoverPause: true,
	 responsive: {
		0: { 
            items: 1,
            stagePadding: 50,
            margin: 0,
        },
		540: { 
          items: 1,
          stagePadding: 80,
          margin: 0,  
             },
		768: { items: 3 }
    }
   });
  
   $('.why-feed-carousel').owlCarousel({
	 loop: true,
     center: true,
	 autoplay: false,
     autoplayHoverPause: true,
	 responsive: {
		0: { 
            items: 1,
            stagePadding: 50,
            margin: 16,
        },
		540: { 
          items: 1,
          stagePadding: 50,
          margin: 16,
             },
		768: { items: 3,
             	 margin: 16
             }
    }
   });
  
  
//   $('.customers-testimonials').owlCarousel({
//     stagePadding: 50,
//     loop:true,
//     items:3,
//     lazyLoad: true,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     autoplayTimeout: 5000,
//     autoplayHoverPause: true
// })

  
});